export default __webpack_public_path__ + "static/1966-4768d969a85471b17c22d257360f4d4b.gif";